import { AbstractControl, ValidatorFn } from '@angular/forms';

export function requiredValidator(): ValidatorFn {
    return ( control: AbstractControl ): { [key: string]: any } => {
        return control.dirty && (control.value == undefined || control.value === '') ? { 'requiredValidation': 'required' } : null ;
    };
}